import React, { useState } from "react";
import instance from "../../api/api.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Header } from "../../shared/compoments";
function CreateCategorie() {
  const MySwal = withReactContent(Swal);
  const [isLoadingChange, setIsLoadingChange] = useState(false);
  const [data, setData] = useState({
    label: "",
  });
  const handleCatgeorie = async () => {
    setIsLoadingChange(true);
    if(!data.label){
      MySwal.fire({
        title: "Veuillez renseigner le champ",
        icon: "info",
        showConfirmButton: true,
      });
    }
    try {
      const response = await instance.post("categories", data);
      console.log("responseCreate", response.data);
      if (response.data.status === true) {
        MySwal.fire({
          title: `La catégorie ${data.label} a été créé avec succès `,
          icon: "success",
          showConfirmButton: true,
        });
      }
      if (response.data.status === false) {
        MySwal.fire({
          title: response.data.message.label[0],
          icon: "info",
          showConfirmButton: true,
        });
      }
      setIsLoadingChange(false);
    } catch (error) {
      console.log(error);
      if(error.response.status !== 500){
        MySwal.fire({
          title: error.response.data.message,
          icon: "info",
          showConfirmButton: true,
        });
      }
      
      setIsLoadingChange(false);
    }
  };
  return (
    <div>
      {/* <h1>Enregistrer une catégorie</h1> */}
       <Header libelle={"Enregistrer une catégorie"} />
      <div className="my-3 px-3">
        <label htmlFor="categorie">Libellé</label>
        <input
          type="text"
          id="categorie"
          value={data.label}
          onChange={(e) => setData({ ...data, label: e.target.value })}
        />
        <button
          onClick={() => handleCatgeorie()}
          className="btn-lg bg-warning mx-2 border-0 rounded-3 p-2 text-dark fw-bold"
        >
          {isLoadingChange ? "Chargement..." : "Créer"}
        </button>
      </div>
    </div>
  );
}

export default CreateCategorie;
